import api, { BASE_URL } from "../../api";

const ORDER_STATUS_OPTION_BASE_URL = `${BASE_URL}/shop/admin/order-status/`;

const listOrderStatusOptions = context => {
  return api(context)
    .get(ORDER_STATUS_OPTION_BASE_URL)
    .then(response => response.data);
};

const getOrderStatusOption = (context, key) => {
  return api(context)
    .get(`${ORDER_STATUS_OPTION_BASE_URL}${key}/`)
    .then(response => response.data);
};

const updateOrderStatusOption = (context, orderStatusOption) => {
  return api(context)
    .patch(
      `${ORDER_STATUS_OPTION_BASE_URL}${orderStatusOption.key}/`,
      orderStatusOption
    )
    .then(response => response.data);
};

const insertOrderStatusOption = (context, orderStatusOption) => {
  return api(context)
    .post(ORDER_STATUS_OPTION_BASE_URL, orderStatusOption)
    .then(response => response.data);
};

const deleteOrderStatusOption = (context, orderStatusKey) => {
  return api(context)
    .delete(
      `${ORDER_STATUS_OPTION_BASE_URL}${orderStatusKey}/`)
    .then(response => response.data);
};

export const orderStatusOption = {
  BASE_URL: ORDER_STATUS_OPTION_BASE_URL,
  list: listOrderStatusOptions,
  get: getOrderStatusOption,
  update: updateOrderStatusOption,
  insert: insertOrderStatusOption,
  delete: deleteOrderStatusOption,
};

export default orderStatusOption;
